import React from "react";

import clsx from "clsx";

import RequestCallbackForm from "components/request-callback/form";

import Heading from "../../heading";
import HeroSection from "../../hero-section";
import DiscoverEnerflo from "./discover-enerflo";
import HelpAndSupport from "./help-and-support";
import styles from "./index.module.css";

const Content = () => (
  <HeroSection>
    <div className="flex-grow text-center px-4 md:text-left md:px-6 md:space-y-0 lg:px-6">
      <div className="flex flex-col md:flex-row md:overflow-hidden md:flex-wrap gap-4">
        <div className={clsx(styles.box, "text-left")}>
          <HelpAndSupport />
        </div>
        <div className={clsx(styles.box, "text-left")}>
          <DiscoverEnerflo />
        </div>
        <div className={clsx(styles.box, "!basis-full xl:!basis-0")}>
          <Heading tag="h4">Request a Callback</Heading>
          <p className={styles.subheading}>
            Complete the form below and an Enerflo Platform Consultant will get back to you shortly.
          </p>
          <div className="mt-6">
            <RequestCallbackForm show />
          </div>
        </div>
      </div>
    </div>
  </HeroSection>
);

export default Content;
